import "./RowGray.css";
import "../SpecialRow.css";
import {Container} from "react-bootstrap";

export default function RowGray(props) {
    return (
        <div className={`special-row row-gray 
            ${props.borderTop ? "golden-line-top" : ""} 
            ${props.borderBottom ? "golden-line-bottom" : ""}
        `}>
            <Container>
                {props.children}
            </Container>
        </div>
    )
}